import React from 'react'
import PropTypes from 'prop-types'

export default class Spinner extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isWhite: PropTypes.bool,
    isGrey: PropTypes.bool,
  }

  render() {
    const {className, isGrey, isWhite} = this.props
    return (
      <div
        className={`spinner ${
          isGrey
            ? 'spinner--grey'
            : isWhite
            ? 'spinner--white'
            : 'spinner--blue'
        } ${className}`}
      >
        <div className={'spinner__image'} />
      </div>
    )
  }
}
